export const DEFAULT_CURRENCY_CODE = 'OMR';
export const OMN_COUNTRY_CODE = 'OM';
export const DEFAULT_TAX_SCHEME = 'VAT';
export const DEFAULT_DOCUMENT_SOURCE = 'WEB';
export const SALES = 'sales';

// Allowance calculation types
export const PERCENTAGE = 'PERCENTAGE';
export const ABSOLUTE = 'ABSOLUTE';
export const ALLOWANCE = 'ALLOWANCE';
export const CHARGE = 'CHARGE';

// document type code
export const SALES_INVOICE_DOCUMENT_TYPE_CODE = '380';
export const PURCHASE_INVOICE_DOCUMENT_TYPE_CODE = '389';
export const CREDIT_NOTE_DOCUMENT_TYPE_CODE = '381';
export const PURCHASE_CREDIT_NOTE_DOCUMENT_TYPE_CODE = '261';
export const DEBIT_NOTE_DOCUMENT_TYPE_CODE = '383';

export const DEFAULT_SALES_TRANSACTION_TYPE_CODE = '10000000000000000000';
export const DEFAULT_PURCHASE_TRANSACTION_TYPE_CODE = '10100000000000000000';
export const DEFAULT_CUSTOMER_TYPE = 'BUSINESS';

export const DEFAULT_ITEM_TYPE = 'Goods';
export const DEFAULT_NATURE_CODE = '';
export const DEFAULT_COMMODITY_CODE = "";
export const DEFAULT_ITEM_CLASSIFICATION_CODE = "";
export const DEFAULT_ITEM_CLASSIFICATION_SCHEME_ID = "";
export const DEFAULT_INCOTERMS = "";
